import React from "react";
import PropTypes from "prop-types";
import BaseModal from "../../../../components/BaseModal";
import { MODAL_TYPES } from "../../../../utils/emitter";
import LastAnswer from "../LastAnswer";
import models from "../../../../types/models";
import "./style.scss";
import { observer } from "mobx-react-lite";

export default observer(function MobileModalLastAnswers({ card }) {
  MobileModalLastAnswers.propTypes = {
    card: PropTypes.oneOfType([models.gameCard, models.compromiseGameCard]),
  };
  return (
    <BaseModal
      className="mobile-last-answers"
      eventTypeModal={MODAL_TYPES.MOBILE_LAST_ANSWERS}
      contentStyle="mobile-last-answers__last-answers"
    >
      <LastAnswer card={card} className="mobile-last-answers__answer" />
    </BaseModal>
  );
});
